import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installationVorbereiten } from './bereiche/anmeldung/lib/desktop'

// Chrome/Edge melden die Installierbarkeit oft schon beim Laden — vor React.
installationVorbereiten()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
